// extracted by mini-css-extract-plugin
export default {"leaderboard":"Leaderboard_leaderboard__Rwwo+"};